import rejectShareObjectMutation from 'api/ShareObject/rejectShareObjectMutation';
import useClient from 'api/client';
import { useAlert } from 'components/message/AlertContext';

export default function useRejectShareObjectMutation(shareUri: string) {
    const client = useClient();
    const { openAlert } = useAlert();

    const rejectShareObject = async (reason?: string) => {
        const response = await client.mutate(
            rejectShareObjectMutation(shareUri, reason),
        );
        if (!response.errors) {
            openAlert({
                message: 'Rejection of shared request successful',
                severity: 'success',
            });
        } else {
            openAlert({
                message: `Could not reject share request. ${response.errors[0]?.message}`,
                severity: 'alert',
            });
        }
    };

    return rejectShareObject;
}
